<template>
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_11110_362)">
      <path d="M18.7621 8.83325C18.4859 8.83325 18.2621 9.05711 18.2621 9.33325C18.2621 9.60939 18.4859 9.83325 18.7621 9.83325H21.4597L17.6466 13.6464C17.4513 13.8416 17.4513 14.1582 17.6466 14.3535C17.8419 14.5487 18.1585 14.5487 18.3537 14.3535L22.1668 10.5404V13.238C22.1668 13.5142 22.3907 13.738 22.6668 13.738C22.943 13.738 23.1668 13.5142 23.1668 13.238V9.33325C23.1668 9.05711 22.943 8.83325 22.6668 8.83325H18.7621Z"/>
      <path d="M13.2383 23.1666C13.5144 23.1666 13.7383 22.9427 13.7383 22.6666C13.7383 22.3904 13.5144 22.1666 13.2383 22.1666H10.5406L14.3537 18.3535C14.549 18.1582 14.549 17.8416 14.3537 17.6464C14.1585 17.4511 13.8419 17.4511 13.6466 17.6464L9.8335 21.4595V18.7618C9.8335 18.4857 9.60964 18.2618 9.3335 18.2618C9.05735 18.2618 8.8335 18.4857 8.8335 18.7618V22.6666C8.8335 22.9427 9.05735 23.1666 9.3335 23.1666H13.2383Z"/>
    </g>
    <defs>
      <clipPath id="clip0_11110_362">
        <rect width="16" height="16" fill="white" transform="translate(8 8)"/>
      </clipPath>
    </defs>
  </svg>
</template>
